<app-lecture-detail-nav [course]="courseObservable | async" [lecture]="lectureObservable | async" [lectures]="lecturesObservable | async"></app-lecture-detail-nav>
<main class="h-97">
  <router-outlet></router-outlet>
</main>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-detail/lecture-detail.component.html